import { defineMessages } from 'react-intl';

export default defineMessages({
  networkError: {
    id: 'app.utils.hooks.networkError',
    defaultMessage: 'Network error when trying to send your message.',
  },
});
